<!--
 * @Author: yindengli
 * @Date: 2023-09-26 18:23:00
 * @LastEditTime: 2023-10-19 16:35:36
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\login\resetPwd.vue
-->
<template>
  <div class="reset-pwd">
    <div class="reset-title">重置密码</div>
    <pwd-input titleName="密码" ref="pwd" placeholder="请填写6-20数字、字母至少两种组合"/>
    <pwd-input titleName="确认密码" ref="comfirmPwd" placeholder="再次输入新密码"/>
    <button class="submit" @click="updatePwd">确认修改</button>
  </div>
</template>

<script>
import pwdInput from './pwdInput.vue';
import request from '@/utils/request'

export default {
  components: { pwdInput },
  props: {
    loginKey: {
      type: String,
      default: ""
    }
  },
  data() {
    return {

    }
  },
  methods: {
    updatePwd() {
      // const pwdStr = this.$refs.pwd && this.$refs.pwd.getPwdValue();
      const pwdStr = this.$refs.pwd && this.$refs.pwd.passwordValue;
      // const confirmPwdStr = this.$refs.comfirmPwd && this.$refs.comfirmPwd.getPwdValue();
      const confirmPwdStr = this.$refs.comfirmPwd && this.$refs.comfirmPwd.passwordValue;
      request({
        url: "/faq/login/userInfo/openUpdatePwd",
        method: 'post',
        data: {token: this.loginKey, password: pwdStr, againPwd: confirmPwdStr}
      }).then(res => {
          if (res && res.data && res.data.errMsg) {
            this.$message.error(res.data.errMsg);
          } else {
             // 重置密码成功
            this.success();
          }
      })
    },
    success() {
      let self = this;
      this.$success({
        title: '信息',
        content: (
          <div>
            <p>重置成功，请重新登录</p>
          </div>
        ),
        onOk() {
          self.resetSuc();
        }
      });
    },
    resetSuc() {
      this.$emit("resetSuc")
    }
  }
}
</script>

<style lang="scss" scoped>
.reset-pwd {
  padding: 0 55px;
}
.reset-title {
  width: 100%;
  font-size: 26px;
  text-align: center;
  color: rbg(0,0,0);
  margin-bottom: 30px;
  margin-top: 20px;
}
.submit {
  border-radius: 40px;
  width: 100%;
  color: #fff;
  background-color: #40a9ff;
  border-color: #40a9ff;
  border: none;
  height: 45px;
  font-size: 16px;
  cursor: pointer;
  // margin: 20px 0;
}
</style>>
